export const constructStrRep = (obj) => {
  return obj.str_representation || obj.title || "Anpassad dimension";
};

export const detailUrl = ({ id }) => {
  return `/rental-notifications/invoicing-objects/custom-dimensions/${id}`;
};
